import React, { useState, useEffect, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { estadoServicio, formatoFechasEs} from "../../functions/funciones";
import NoVisitado from "../noVisitadoComunidad";
import { Box, Typography, Tooltip, Modal, TextField, Button, FormControlLabel, Switch } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import { DataTable } from "../../components";
import "./comunidad.css";
import Add from "../../icons/add.svg";
import Swal from 'sweetalert2';

import { DeleteSale, getListSalesToExport, getSales, getReporteVisitasExcel } from "../../services";
import { toast } from "react-toastify";
import FiltrosVentas from "../filtros/filtrosVentas";
import { FaPencilAlt } from "react-icons/fa";
import CircularProgress from '@mui/material/CircularProgress';
import { TbCertificate } from "react-icons/tb";
import { IoVideocam } from "react-icons/io5";
import { TiDocumentText } from "react-icons/ti";
import { MdHealthAndSafety } from "react-icons/md";
import { IoIosWarning } from "react-icons/io";
import { HiClipboardDocumentList } from "react-icons/hi2";
import { BsTrash } from "react-icons/bs";
import { UsuarioContext } from "../../providers/userContext";
import Enlace from "../Enlace";
import { useRecogerURLParamsFiltros, construirURLParamsFiltros } from './../../functions/parametrosURL/funcionesParamsURL';
import ExportarListaServicios from "../../routes/pages/admin/ExportarListaServicios";
import NoVisitadoAAFF from "../../components/noVisitadoAAFF";
import ExportarListaPlantillaLopdSev from "../../routes/pages/admin/ExportarListaPlantillaLopdSev";
import Excel from "../../icons/excel.svg";

const EMAIL_EXCLUIDO_EXCEL = "ane.nieto@grupolae.net";

const modalCenterStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
const modalBoxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  zIndex: 1000,
};
const modalPaperStyle = {
  backgroundColor: "#fff",
  border: "2px solid #000",
  boxShadow:
    "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
  padding: "16px 32px 24px",
};

export default function ComunidadDocs(props) {
  const { t } = useTranslation(['common']);
  const { idPropiedad, grupoServicio } = props

  const user = useContext(UsuarioContext)
  const canEdit = user.rol === "ADMIN" || user.rol === "CONSUL" || user.rol === "VENT"

  const [primeraCarga, setPrimeraCarga] = useState(true);
  const { filtrosIniciales, filtroOrder } = useRecogerURLParamsFiltros();
  const tieneFiltrosAplicados = Object.keys(filtrosIniciales).length > 0;
  const [loading, setLoading] = useState(idPropiedad !== undefined || tieneFiltrosAplicados);
  const [loadingXls, setLoadingXls] = useState(false);
  const [busquedaIniciada, setBusquedaIniciada] = useState(idPropiedad !== undefined || tieneFiltrosAplicados); 
  const filterCheckBox = user.rol === "TECH" || user.rol === "TECH_COOR" ? {...filtrosIniciales,visitasRecientes: true} : filtrosIniciales;
  const [busqueda, setBusqueda] = useState(filterCheckBox);
  const [recargar, setRecargar] = useState(false);
  const [busquedaActiva, setBusquedaActiva] = useState(false);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });

  const puedeReporteVisitas =
    user?.rol === "ADMIN" &&
    (user?.email || "").toLowerCase() !== EMAIL_EXCLUIDO_EXCEL;

  const [modalReporteOpen, setModalReporteOpen] = useState(false);
  const [fechaInicioReporte, setFechaInicioReporte] = useState("");
  const [fechaFinReporte, setFechaFinReporte] = useState("");
  // Quita del reporte las comunidades marcadas con motivo de no visita
  const [excluirNoVisita, setExcluirNoVisita] = useState(false);
  const [descargandoReporte, setDescargandoReporte] = useState(false);

  const abrirModalReporte = () => {
    setFechaInicioReporte("");
    setFechaFinReporte("");
    setExcluirNoVisita(false);
    setModalReporteOpen(true);
  };

  const cerrarModalReporte = () => {
    if (descargandoReporte) return;
    setModalReporteOpen(false);
  };

  const generarReporteVisitas = async () => {
    if (!fechaInicioReporte || !fechaFinReporte) {
      toast.warn(t('excel.selectBothDates'));
      return;
    }
    if (fechaInicioReporte > fechaFinReporte) {
      toast.warn(t('excel.invalidDateRange'));
      return;
    }
    setDescargandoReporte(true);
    try {
      const blobData = await getReporteVisitasExcel(fechaInicioReporte, fechaFinReporte, excluirNoVisita);
      const blob = new Blob([blobData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `visitas_por_tecnico_${fechaInicioReporte}_al_${fechaFinReporte}${excluirNoVisita ? '_sin_no_visita' : ''}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      setModalReporteOpen(false);
    } catch (error) {
      console.error(error);
      toast.error(t('excel.visitsReportError'));
    } finally {
      setDescargandoReporte(false);
    }
  };

  const navigate = useNavigate();
  const location = useLocation();
  
  const refControladorAborto = useRef(null);

  const params = useParams();
  const url = params['*'].split('/')[0];
  
  const clearFilters = () => {
    if (user.rol === "CONSUL" && localStorage.getItem("hasReloaded") === "true") {
      setBusqueda({
        consul_id: user.id 
      });
    }
    else if(user.rol === "CONSUL"){
      setBusqueda({
        consul_id: user.id 
      });
    }
    
    else{
      setBusqueda(user.rol === "TECH" || user.rol === "TECH_COOR" ? {visitasRecientes: true} : {});
    }
    
    setClearFilterActivo(true);
  };
  const comunidadesRows = [
    {
      id: "color",
      numeric: false,
      disablePadding: false,
      label: "",
      noObjeto: false,
      overrideFunc: (data, row) => (
        <Typography
          style={{ width: '3px', height: '6vh', background: data }}>
        </Typography>
      )
    },
    {
      id: "ano",
      numeric: false,
      disablePadding: false,
      label: t('services.columns.year'),
      noObjeto:true,
      overrideFunc: (data, row) => (
        <Typography
          style={{ background: row, padding: '18px 10px' }}
        >
          {data}
        </Typography>
      ),
    },
    {
      id: "servicio",
      numeric: false,
      disablePadding: false,
      label: t('services.columns.service'),
      noObjeto:true,
    },
    ...(user.rol !== "ADMIN_CAI" ? [
      {
        id: "prop_estado_cae",
        numeric: false,
        disablePadding: false,
        label: t('filters.stateCae'),
        noObjeto:true,
        overrideFunc: (data, row) =>
        !row.isWorkcenter ? (
          <Typography
            style={{
              color:
                data === 1 || data == null
                  ? "#3eae3e"
                  : data === 2 || data === 3
                  ? "#FF8300"
                  : data === 4 || data === 5
                  ? "#EE4534"
                  : "#000",
            }}
          >
              {data === "-" ? data : estadoServicio(data, t)}
            </Typography>
        ) : (
          ""
        ),
      },
      {
        id: "prop_estado_lopd",
        numeric: false,
        disablePadding: false,
        label: t('filters.stateLopd'),
        noObjeto:true,
        overrideFunc: (data, row) =>
        !row.isWorkcenter ? (
          <Typography
            style={{
              color:
                data === 1 || data == null
                  ? "#3eae3e"
                  : data === 2 || data === 3
                  ? "#FF8300"
                  : data === 4 || data === 5
                  ? "#EE4534"
                  : "#000",
            }}
          >
              {data === "-" ? data : estadoServicio(data, t)}
            </Typography>
        ) : (
          ""
        ),
      },
    ] : []),
    {
      id: "prop_estado_cai",
      numeric: false,
      disablePadding: false,
      label: t('filters.stateCai'),
      noObjeto:true,
      overrideFunc: (data, row) =>
      !row.isWorkcenter ? (
        <Typography
          style={{
            color:
              data === 1 || data == null
                ? "#3eae3e"
                : data === 2 || data === 3
                ? "#FF8300"
                : data === 4 || data === 5
                ? "#EE4534"
                : "#000",
          }}
        >
            {data === "-" ? data : estadoServicio(data, t)}
          </Typography>
      ) : (
        ""
      ),
    },
    ...(idPropiedad === undefined ? [{
      id: "nif",
      numeric: false,
      disablePadding: false,
      label: t('services.columns.nif'),
      noObjeto:true,
    }] : []),
    {
      id: "comunidad",
      numeric: false,
      disablePadding: false,
      label: t('services.columns.community'),
      noObjeto:true,
      overrideFunc: (data, row) => (
        idPropiedad === undefined ? 
          <Link to={user.rol === "AAFF" ? "/comunidades/" + row.finca.nif : "/aaff/" + row.nif_aaff + "/comunidades/" + row.finca.nif} >{data}</Link>
        : idPropiedad !== undefined && row.isWorkcenter ?
          <Typography>
            {data}
          </Typography>
        :null
      ),
    },
    {
      id: "direccion",
      numeric: false,
      disablePadding: false,
      label: t('services.columns.address'),
      noObjeto:true,
      overrideFunc: (data, row) => (
        <Typography>
          {data} 
        </Typography>
      ),
    },
    ...(idPropiedad === undefined ? [{
      id: "codigoPostal",
      numeric: false,
      disablePadding: false,
      label: t('services.columns.postalCode'),
      // noObjeto:true,
    }] : []),

    ...(user.rol !== 'TECH' || user.rol !== 'TECH_COOR' ?
    [{
      id: "saleDate",
      numeric: false,
      disablePadding: false,
      label: t('services.columns.saleDate'),

      overrideFunc: (data) => data ? formatoFechasEs(data) : '',
    }]:[]),

    {
      id: "documentos",
      numeric: false,
      disablePadding: false,
      label: t('services.columns.documents'),
      colSpan: 4,
      noObjeto:true,
      overrideFunc: (data, row) => (
        <Typography style={{ display: 'flex', gap: 5, color: '#fff' }}>
          {(row.all_row.serviceprops.id === 1 || row.all_row.serviceprops.id === 3 || row.all_row.serviceprops.id === 6 || row.all_row.serviceprops.id === 7) && (
            <>

              {renderDocs(t('services.documents.visitSheet'), <HiClipboardDocumentList />, "hoja-visita", row.all_row, "cae")}


              {renderDocs(t('services.documents.riskIdentification'), <MdHealthAndSafety />, "identificacion-riesgos", row.all_row, "cae")}


              {renderDocs(t('services.documents.emergencyMeasures'), <IoIosWarning />, "medidas-emergencia", row.all_row, "cae")}

            </>
          )}
          {(row.all_row.serviceprops.id === 2 || row.all_row.serviceprops.id === 4) && (
            <>
              {renderDocs(t('services.documents.certificate'), <TbCertificate />, row.all_row.serviceprops.id === 4 ? 'certificado-auditoria' : 'certificado-implantacion', row.all_row, "lopd")}
              {renderDocs(t('services.documents.implementation'), <TiDocumentText />, 'documentacion-implantacion', row.all_row, "lopd")}

              {row.all_row.serviceprops.id === 4 ?
                renderDocs(t('services.documents.audit'), <TiDocumentText />, 'documentacion-auditoria', row.all_row, "lopd")
                : null}

              {row.all_row.detailsLopd[0]?.surveillanceVideo ? renderDocs(t('services.documents.videoSurveillance'), <IoVideocam />, "video-vigilancia", row.all_row, "lopd") : ''}

            </>
          )}
          {(row.all_row.serviceprops.id === 5) && (
            <>
              {renderDocs(t('services.documents.lopd'), <TbCertificate />, 'lopd', row.all_row, "lopd")}
            </>
          )}
          {(row.all_row.serviceprops.id === 8 || row.all_row.serviceprops.id === 9) && (
            <>
              {renderDocs("Certificado", <TbCertificate />, 'certificado-accesibilidad', row.all_row, "cai")}
              {renderDocs("Informe", <TiDocumentText />, 'informe-accesibilidad', row.all_row, "cai")}
            </>
          )}
        </Typography>
      )
    },
    ...(props.grupoServicio === 1 || props.grupoServicio === 3 || props.grupoServicio === undefined ?
      [{
        id: "tecnico",
        numeric: false,
        disablePadding: false,
        label: t('services.columns.technician'),
        noObjeto:true,
        overrideFunc: (data, row) => data,
      }] : []),

    {
      id: "fechaRealizada",
      numeric: false,
      disablePadding: false,
      label: t('services.columns.performedDate'),
      noObjeto:true,
      overrideFunc: (data) => data ? formatoFechasEs(data) : '',
    },
    ...(idPropiedad === undefined ? [{
      id: "fechaRealizadaAnterior",
      numeric: false,
      disablePadding: false,
      label: t('services.columns.previousCompletedDate'),
      // noObjeto:true,
      overrideFunc: (data) => data ? formatoFechasEs(data) : '',
    }] : []),
    ...(canEdit ?
      [{
        id: "editar",
        numeric: false,
        disablePadding: true,
        label: "",
        noObjeto:true,
        overrideFunc: (data, row) => (
          <Typography
            style={{ width: '100px' }}>
            {props.grupoServicio === 1 || props.grupoServicio === undefined 
            ? 
              // Sin marca del AAFF, el componente muestra el no visitado de la venta (fallback)
              data.detailsCae[0]?.visitSheet_id === null && !data.detailsCae[0]?.visitada
              ?
                <NoVisitadoAAFF
                  aaff={row.aaff}
                  nif={row.aaff?.nif}
                  servicio="CAE"
                  fallback={<NoVisitado finca={row.all_row} nif={row.finca.nif} tipo={"finca"} />}
                />
              :
                <NoVisitado finca={row.all_row} nif={row.finca.nif} tipo={"finca"} /> 
            : 
              null}
            <Link to={`/servicios/editar/${row.editar.id}`} ><FaPencilAlt /></Link>
            <Link to={''} onClick={() => comprobarEliminarVenta(row.editar.id)} style={{ marginLeft: '10px' }}><BsTrash /></Link>
          </Typography>
        ),
      }] : []),
  ];
  const enlaceToDocType = {
    'identificacion-riesgos': 'evaluacionRiesgos',
    'hoja-visita': 'hojaVisita',
    'medidas-emergencia': 'planEmergencia',
    'lopd': 'LOPD'
  }

  const renderDocs = (nombre, icono, enlace, row, tipo) => {

    let documento;
    let url;
    if (tipo === "lopd" && enlace !== 'lopd') {
      documento = row.detailsLopd?.find(obj => obj.sale_id === row.id);
    }
    if (tipo === "lopd" && enlace === 'lopd') {
      const tieneRuta = row.docsProps?.find(doc => doc.type === enlaceToDocType[enlace])?.ruta;
      documento = tieneRuta ? { visitada: true } : null;
    }
    if (tipo === 'cae') {
      documento = row.detailsCae?.find(obj => obj.sale_id === row.id);
    }
    if (tipo === 'cai') {
      documento = row.detailsCai?.find(obj => obj.sale_id === row.id);
    }
    
    if (!documento) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: 16 }}>
          <Tooltip title={nombre} style={{ fontSize: '16px' }}>
            <small
              className="docsStatus"
              style={{ background: '#FF5252', height: 'auto' }}
            >
              {icono}
            </small>
          </Tooltip>
        </div>
      );
    }

    const { pendiente, visitada } = documento;

    if ((tipo === "lopd" && enlace !== 'lopd') ||
      ((tipo === 'cae' || tipo === 'cai') && (pendiente || visitada))) {
      if (row.workcenters === null) {
        url = `/doc-render/${row.properties?.nif}/${row.id}/${enlace}`
      } else {
        url = `/doc-render/${row.properties?.nif}/${row.workcenters.id}/${row.id}/${enlace}`
      }
    }
    if (
      (tipo === "lopd" && enlace === "lopd") ||
      ((tipo === "cae" && !documento?.visitSheet_id) || (tipo === "cai" && !documento?.visitSheetCai_id))
    ) {
      url =
        process.env.REACT_APP_STORAGE_URL +
        row.docsProps?.find((doc) => doc.type === enlaceToDocType[enlace])
          ?.ruta;
    }
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

        {!pendiente && !visitada ?
          <Tooltip title={nombre} style={{ fontSize: '16px' }}>
            <small
              className="docsStatus"
              style={
                { background: '#FF5252' }
              }
            >
              {icono}
            </small>
          </Tooltip>
          :
          <Enlace to={url} target={"_blank"}>
            <Tooltip title={nombre} style={{ fontSize: '16px' }}>
              <small
                className="docsStatus"
                style={
                  visitada ?
                    { background: '#7bc977' }
                    : pendiente ?
                      { background: '#FCBA03' }
                      : { background: '#FF5252' }
                }
              >
                {icono}
              </small>
            </Tooltip></Enlace>
        }

      </div>
    );
  };


  // useEffect(() => {
  //   fetchData();
  // },[recargar])

  // listado simple con los ct independientes de las comunidades

  const color = ['#0767A2', '#B96800', '#409FD9', '#EE8D11', "", "#77AF6E", "#77D860", "#ffd752", "#f8de87"]
  const formatData = (data) => {
    // console.log("datos",data)
    const formattedData = [];
    data.forEach((row) => {
      const gruposCae = [1, 3, 6, 7];
      const gruposLopd = [2, 4, 5];
      const gruposCai = [8, 9];
      const ventasAll = row?.estadosVentasAll || [];
      const anoRow = new Date(row.saleDate).getFullYear();
      // Estado de la venta de un grupo de servicios correspondiente al MISMO año que la fila actual.
      const estadoSalesYear = (grupos) => {
        const ventas = ventasAll.filter(
          (s) => grupos.includes(s.servp_id) && new Date(s.saleDate).getFullYear() === anoRow
        );
        if (ventas.length === 0) return undefined;
        return ventas.reduce((a, b) => (b.id > a.id ? b : a)).estado_id;
      };
      // mostrar el estado de la venta de cada servicio por cada año individualmente
      const estadoPropio = ventasAll.find((s) => s.id === row.id)?.estado_id ?? row.estado_id;
      const estado_cae = gruposCae.includes(row.servp_id) ? estadoPropio : estadoSalesYear(gruposCae);
      const estado_lopd = gruposLopd.includes(row.servp_id) ? estadoPropio : estadoSalesYear(gruposLopd);
      const estado_cai = gruposCai.includes(row.servp_id) ? estadoPropio : estadoSalesYear(gruposCai);
      formattedData.push({
        color: color[row.serviceprops.id-1],
        aaff: row.aaff,
        primeraPendiente: new Date(row.properties.sales.filter(sale => sale.detailsCae.some(detail => detail.visitada === false)).map(sale => (sale.saleDate))[0]).getFullYear(),
        ano: new Date(row.saleDate).getFullYear(),
        servicio: row.serviceprops.nombre,
        nif: row.properties.nif,
        nif_aaff: row.aaff.nif,
        finca: row.properties,
        comunidad: row.properties?.razonSocial,
        direccion: row.workcenters && Object.keys(row.workcenters).length > 0 ? row.workcenters?.razonSocial : row.properties?.direccion,
        codigoPostal: row.properties.codigoPostal,
        saleDate: row.saleDate,
        fechaEnvio: row.adviceDate,
        all_row: row,
        // impagada: row.estado_factura_id === 2,
        noVisita: typeof row.detailsCae?.[0] !== 'undefined' && row.detailsCae[0]?.unRealized,
        fechaRealizada: 
          row.servp_id === 2 || row.servp_id === 4 ? 
            row.adviceDate 
          : !row.detailsCae?.[0]?.unRealized && row.detailsCae?.[0]?.visitSheet?.visitDate !== null && row.detailsCae?.[0]?.visitSheet?.visitDate !== undefined ? 
            row.detailsCae[0]?.visitSheet?.visitDate 
          : !row.detailsCai?.[0]?.unRealized && row.detailsCai?.[0]?.visitSheetCai?.visitDate !== null && row.detailsCai?.[0]?.visitSheetCai?.visitDate !== undefined ? 
            row.detailsCai[0]?.visitSheetCai?.visitDate 
          : '',
        fechaRealizadaAnterior:  row.detailsCae?.[0]?.fechaRealizadaAnterior ?? '',
        editar: row,
        details_lopd: row.detailsLopd?.length,
        details_cae: row.detailsCae?.[0]?.visitada === undefined ? null : row.detailsCae[0].visitada,
        unRealized: row.detailsCae?.[0]?.unRealized,
        tecnico: row?.technician ? row?.technician?.nombre + " " + row?.technician?.apellidos : "",
        isWorkcenter: row.workcenters ? true : false,
        prop_estado_cae: estado_cae ? estado_cae === null
        ? 1
          : estado_cae
        : "-",
        prop_estado_lopd: estado_lopd ? estado_lopd === null
        ? 1 
          : estado_lopd
        : "-",
        prop_estado_cai: estado_cai ? estado_cai === null
        ? 1 
          : estado_cai
        : "-",
      })
    })
    if (props.idPropiedad !== undefined) {
      formattedData.sort((a, b) => new Date(b.saleDate || 0) - new Date(a.saleDate || 0));
    }
    return formattedData;
  };
  /* @JUANK PENDIENTE A USAR EL HOOK*/
  // const formatData = (data) => {
  //   const formattedData = []
  //   data.map((row) => {
  //     formattedData.push({

  //     })
  //     if(Object.keys(row.workcenters)?.length > 0){
  //       formattedData.push({})
  //     }
  //   })
  // }

  const handleCallback = () => {
    setRecargar((prev) => !prev);
  };
 
  const comprobarEliminarVenta = async (id) => {
    // Llama a la función importada y pasa la devolución de llamada
    eliminarVenta(id).then((resultado) => {
      handleCallback(resultado)
    })
  };

  const eliminarVenta = async (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const result = await Swal.fire({
          title: t('services.messages.deleteSale'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#888",
          cancelButtonText: t('actions.cancel'),
          confirmButtonText: t('actions.delete')
        });

        if (result.isConfirmed) {
          const toastInfo = toast.info(t('services.messages.deletingSale'), { autoClose: false });
          await DeleteSale(id)
            .then(() => {
              toast.update(toastInfo, {
                render: t('services.messages.deletedSuccess'),
                type: toast.TYPE.SUCCESS,
                autoClose: true
              });
              resolve(true);
            })
            .catch(error => {
              console.log(error);
              toast.update(toastInfo, {
                render: t('services.messages.deleteError'),
                type: toast.TYPE.ERROR,
                autoClose: true
              });
              reject(error);
            });
        } else {
          // Si el usuario cancela la eliminación
          resolve(false);
        }
      } catch (error) {
        console.error("Error al eliminar la venta:", error);
        reject(error);
      }
    });
  };
  
  const fetchData = async ({ offset, limit, filtros = busqueda,order,orderBy } = {}) => {

    if (!busquedaIniciada) {
      return;
    }

    if (refControladorAborto.current) {
      refControladorAborto.current.abort();
    }
    const nuevoControladorAborto = new AbortController();
    refControladorAborto.current = nuevoControladorAborto;

    orderBy = orderBy || filtroOrder.ordenadoPor || 'saleDate';
    order = order || filtroOrder.orden || 'DESC';

    if (primeraCarga) {
      if (filtros.consul_id === undefined && user.rol === 'CONSUL') {
        filtros.consul_id = user.id
      } else if (filtros.consul_id === "0") {
        delete filtros.consul_id
      }
      setPrimeraCarga(false);
    }


    construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros, order, orderBy, grupoServicio);

    try {
      setLoading(true);
      if (props.idPropiedad === undefined) {
        // Excluir searchTimestamp antes de enviar al backend
        const { searchTimestamp, ...filtrosData } = filtros;
        const payload = {
          filtros: user.rol === 'ADMIN' ? filtrosData : { ...filtrosData },
          params: { page: offset, limit: limit, order, orderBy },
          signal: nuevoControladorAborto.signal,
        };
        const response = await getSales(payload)
        const { meta, data } = response;
        setData({
          meta,
          rows: formatData(data),
        });
        console.log("data", data)
      } else {
        let grupoServ_id = null
        if (location.pathname !== '/servicios') {
          grupoServ_id = props.grupoServicio
        }
        const payload = {
          filtros: { prop_id: props.idPropiedad, grupoServ_id },
          params: { page: offset, limit, order, orderBy },
          signal: nuevoControladorAborto.signal,
        };
        const response = await getSales(payload)
        const { meta, data } = response;
        console.log("data", data)
        setData({
          meta,
          rows: formatData(data),
        });
      }
    } catch (error) {
      if (error.name === "CanceledError" || error.name === "AbortError") {
        return;
      }
      console.log(error);
    } finally {

      if (refControladorAborto.current === nuevoControladorAborto) {
        setLoading(false);
      }
    }
  };

  const filtrarDatos = (filtros) => {
    setBusqueda(filtros);
    setBusquedaActiva(true);
    setBusquedaIniciada(true);
    // El cambio en busqueda ya dispara la recarga en DataTable
  }

  useEffect(() => {
    return () => {
      if (refControladorAborto.current) {
        refControladorAborto.current.abort();
      }
    };
  }, []);

  const exportData = async () => {
    const toastId = toast.loading(t('excel.generatingExcel'));
    setLoadingXls(true);
    try {
      const data = await getListSalesToExport({filtros: busqueda});

      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `servicios_${Date.now()}.xlsx`);

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
      toast.update(toastId, {
        render: t('excel.excelSuccess'),
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      setLoadingXls(false);
    } catch (error) {
      console.error(error);
      toast.update(toastId, {
        render: t('excel.excelError'),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
      setLoadingXls(false);
    }
  };
  return (
    <>
      <div className="pageContent tableContainer">
        {props.idPropiedad === undefined && (
          <>
            {user.rol !== "ADMIN_CAI" && (
              <div className="contentBar" style={{ padding: '0 10px' }}>
                <div className="contentBtns"></div>
                <Link to="/servicios/create" target={"_blank"}>
                  <div className="contentButton">
                    <img src={Add} alt={t('actions.more')} />
                  </div>
                </Link>
              </div>
            )}
            {idPropiedad === undefined && // si esta en la ficha de la comunidad los filtros no aparecen
              <FiltrosVentas onFilter={filtrarDatos} clearFilter={clearFilters} filtrosIniciales={busqueda} />
            }
          </>
        )}
        <div style={{ margin:'20 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {/* <ExportarListaServicios filtros={busqueda} /> */}
          {user.rol !== "ADMIN_CAI" && (
            <>
              <div style={{ margin: '20 0', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <button
                  // className="bigBtn"
                  className={`bigBtn ${loading || loadingXls || data.rows.length === 0 ? 'disabled' : ''}`}
                  onClick={exportData}
                  // disabled={loading || loadingXls}
                >
                  {!loadingXls ? (
                    <>
                      <img src={Excel} alt={t('excel.generateList')} width="30px" style={{ marginRight: '10px' }} />
                      <span>{t('excel.generateList')}</span>
                    </>
                  ) : (
                    <>
                      <CircularProgress
                        style={{ color: '#fff', width: '16px', height: '16px', marginRight: '10px' }}
                      />
                      <span>{t('excel.generatingList')}</span>
                    </>
                  )
                  }
                </button>
                {puedeReporteVisitas && (
                  <button
                    className={`bigBtn ${descargandoReporte ? 'disabled' : ''}`}
                    onClick={abrirModalReporte}
                    disabled={descargandoReporte}
                  >
                    {!descargandoReporte ? (
                      <>
                        <img src={Excel} alt={t('excel.visitsReport')} width="30px" style={{ marginRight: '10px' }} />
                        <span>{t('excel.visitsReport')}</span>
                      </>
                    ) : (
                      <>
                        <CircularProgress
                          style={{ color: '#fff', width: '16px', height: '16px', marginRight: '10px' }}
                        />
                        <span>{t('excel.generatingList')}</span>
                      </>
                    )}
                  </button>
                )}
              </div>
              {grupoServicio === 2 || grupoServicio === undefined &&
                <ExportarListaPlantillaLopdSev filtros={busqueda} />
              }
            </>
          )}
        </div>
        <div className="tableWrapper">
          <Box className="pageContent">
            <Box sx={{ mb: 10 }}>
              <DataTable
                data={data.rows}
                isLoading={loading}
                headers={comunidadesRows}
                fetcher={fetchData}
                currentPage={data.current_page}
                meta={data.meta}
                totalItems={data.total}
                totalPages={data.totalPages}
                nextPage={data.next_page}
                filtros={busqueda}
                busquedaActiva={busquedaActiva}
                setBusquedaActiva={setBusquedaActiva}
                clearFilterActivo={clearFilterActivo}
                setClearFilterActivo={setClearFilterActivo}
                mensaje={busquedaIniciada ? t('services.messages.noInfo') : t('services.messages.searchFirst')}
                recargar={recargar}
              />
            </Box>
          </Box>
        </div>
      </div>
      <style jsx="true">{`
        .tableContainer table tbody th.docs, .tableContainer table thead th {
          text-align: center;
        }
        .tableContainer table tbody td {
          padding: 0;
          text-align: center;
        }
      `}</style>

      <Modal
        aria-labelledby="modal-reporte-visitas-title"
        aria-describedby="modal-reporte-visitas-description"
        sx={modalCenterStyle}
        open={modalReporteOpen}
        onClose={cerrarModalReporte}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500, style: { zIndex: 999 } }}
        style={{ zIndex: 1000 }}
      >
        <Box sx={modalBoxStyle}>
          <div style={modalPaperStyle}>
            <h2 id="modal-reporte-visitas-title" style={{ marginBottom: "24px" }}>
              {t('excel.visitsReportModalTitle')}
            </h2>
            <div id="modal-reporte-visitas-description">
              <form noValidate autoComplete="off">
                <div
                  style={{
                    margin: "8px 0",
                    width: "100%",
                    boxSizing: "border-box",
                    position: "relative",
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gridGap: "15px",
                    fontSize: "12px",
                  }}
                >
                  <TextField
                    variant="standard"
                    type="date"
                    id="fechaInicioReporte"
                    name="fechaInicioReporte"
                    label={t('excel.startDate')}
                    value={fechaInicioReporte}
                    onChange={(e) => setFechaInicioReporte(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                  />
                  <TextField
                    variant="standard"
                    type="date"
                    id="fechaFinReporte"
                    name="fechaFinReporte"
                    label={t('excel.endDate')}
                    value={fechaFinReporte}
                    onChange={(e) => setFechaFinReporte(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                  />
                </div>
                <FormControlLabel
                  sx={{ mt: 2, mx: 0, width: "100%", justifyContent: "space-between" }}
                  labelPlacement="start"
                  control={
                    <Switch
                      color="secondary"
                      checked={excluirNoVisita}
                      onChange={(e) => setExcluirNoVisita(e.target.checked)}
                      disabled={descargandoReporte}
                    />
                  }
                  label={t('excel.excludeNoVisit')}
                />
                <div
                  style={{
                    margin: "8px 0",
                    width: "100%",
                    boxSizing: "border-box",
                    position: "relative",
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gridGap: "15px",
                    fontSize: "12px",
                    marginTop: "24px",
                  }}
                >
                  <Button
                    className="btn-Default"
                    variant="contained"
                    onClick={cerrarModalReporte}
                    disabled={descargandoReporte}
                    style={{ opacity: descargandoReporte ? 0.6 : 1, fontSize: '0.875rem' }}
                  >
                    {t('actions.cancel')}
                  </Button>
                  <Button
                    className="btn-Secondary"
                    variant="contained"
                    color="secondary"
                    onClick={generarReporteVisitas}
                    disabled={descargandoReporte}
                    style={{ opacity: descargandoReporte ? 0.6 : 1, fontSize: '0.875rem' }}
                  >
                    {descargandoReporte ? (
                      <CircularProgress style={{ height: 20, width: 20, color: "#fff" }} />
                    ) : (
                      t('excel.generateList')
                    )}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}
